import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDrawerContainer, MatDrawer, MatDrawerContent } from '@angular/material/sidenav';
import { NavigationResponse } from 'app/layout/layout.types';
import { FuseVerticalNavigationComponent as FuseVerticalNavigationComponent_1 } from '../../../../../@fuse/components/navigation/vertical/vertical.component';
import { FuseFullscreenComponent } from '../../../../../@fuse/components/fullscreen/fullscreen.component';
import { NotificationsComponent } from '../../../common/notifications/notifications.component';
import { UserMenuComponent } from '../../../common/user-menu/user-menu.component';
import { LayoutNavigationEntry, VerticalLayoutBaseComponent } from '../vertical-layout-base.component';

@Component({
    selector: 'thin-layout',
    templateUrl: './thin.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FuseVerticalNavigationComponent_1, MatIconButton, MatIcon, RouterLink, FuseFullscreenComponent, NotificationsComponent, UserMenuComponent, MatDrawerContainer, MatDrawer, NgClass, MatDrawerContent, RouterOutlet]
})
export class ThinLayoutComponent extends VerticalLayoutBaseComponent {

    protected navigationChain(navigation: NavigationResponse): LayoutNavigationEntry[] {
        return [
            { roleKey: 'admin', horizontal: navigation.admin, compact: navigation.adminCompact },
            { roleKey: 'customer', horizontal: navigation.customer, compact: navigation.compact },
            { roleKey: 'auditor', horizontal: navigation.auditor, compact: navigation.compact },
            { roleKey: 'salesRep', horizontal: navigation.salesRep, compact: navigation.salesRepCompact, currentRole: 'Sales Rep' }
        ];
    }
}
